import { Component, OnInit, AfterViewInit } from '@angular/core';
import { environment } from '@env/environment';
declare var hbspt: any 

@Component({
  selector: 'app-hub-spot-form',
  templateUrl: './hub-spot-form.component.html',
  styleUrls: ['./hub-spot-form.component.css']
})
export class HubSpotFormComponent implements OnInit,AfterViewInit {
 private formId: string;
 private portId: string;
  constructor() { 
    this.portId = environment.HUB_SPOT_PORTAL_ID;
    this.formId = environment.HUB_SPOT_PORTAL_FORM_ID;
  }

  ngOnInit() {
  }
  ngAfterViewInit(){
    hbspt.forms.create({
      portalId: this.portId,
      formId: this.formId,
      target: "#hubspotForm"
      });
      // window.scrollTo(0, 0); 
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/external/hub-spot-form/hub-spot-form.component.ts